import styles from './ConfirmEmployee.css'
import {connect} from 'react-redux'

class SuccessConfirmEmployee extends React.Component {
  render () {
    let {business} = this.props.data.confirmEmployee.invitedEmployee
    return (business &&
      <div className='container'>
        <div className='row'>
          <div className={styles['confirm-success']}>
            <h1>Success!</h1>
            You can now start accepting payments on behalf of <b>{business.name}</b>
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    data: state
  }
}

export default connect(mapStateToProps)(SuccessConfirmEmployee)



// WEBPACK FOOTER //
// ./app/pages/ConfirmEmployee/SuccessConfirmEmployee.js